import { render, staticRenderFns } from "./MakerLink.vue?vue&type=template&id=58e4b982"
var script = {}
import style0 from "./MakerLink.vue?vue&type=style&index=0&id=58e4b982&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports